// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2840":"e4c678af","3262":"bbb96952","3961":"9ab60ce5","4126":"a93e05b2","4300":"31d6cfe0","7300":"5846ada7","9299":"bbb96952","9356":"09964338"}[chunkId] + ".chunk.css";
};